import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'
import * as translationService from '../services/translationService'
import { updateUserInformation } from '../actions/AuthAction'
import * as routeService from '../services/routeService'
import Button from './../components/Button'
import { TextField, Form } from 'components/Form'

const mapDispatchToProps = dispatch => ({
  updateUserInformation: userInformation => dispatch(updateUserInformation(userInformation)),
})

class LoginView extends React.Component {
  static propTypes = {
    history: PropTypes.any,
    updateUserInformation: PropTypes.func,
    userID: PropTypes.any,
  }

  state = {
    firstname: '',
    lastname: '',
    email: '',
  }

  saveUserInformation = () => {
    this.props.updateUserInformation(this.state).then(data => {
      if (data.success) {
        const historyState = this.props.history.location.state
        routeService.goToPage(historyState && historyState.orginalPath)
      }
    })
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  render() {
    return (
      <div>
        <Form>
          <TextField
            label={translationService.registerFirstNameLabel()}
            id="firstname"
            value={this.state.firstname}
            onChange={this.onValueChange}
          />
          <TextField
            label={translationService.registerLastNameLabel()}
            id="lastname"
            value={this.state.lastname}
            onChange={this.onValueChange}
          />
          <TextField
            type="email"
            label={translationService.registerEmailLabel()}
            id="email"
            value={this.state.email}
            onChange={this.onValueChange}
          />
          <Button onClick={this.saveUserInformation} primary>
            {translationService.buttonNext()}
          </Button>
        </Form>
      </div>
    )
  }
}

export default compose(
  translate('translations'),
  connect(
    {},
    mapDispatchToProps,
  ),
)(LoginView)



// WEBPACK FOOTER //
// ./src/views/userUpdateView.js